import type {
  ApiResponse,
  PaginatedResponse,
  UserSupportConversationDTO,
  UserSupportMessageDTO,
} from '@klaro7/shared-types';

import api from '@/lib/api';

export async function getMyThread(): Promise<UserSupportConversationDTO> {
  const res = await api.get<ApiResponse<UserSupportConversationDTO>>('/user-support/my');
  return res.data.data;
}

export async function listInbox(status?: string): Promise<UserSupportConversationDTO[]> {
  const res = await api.get<ApiResponse<UserSupportConversationDTO[]>>(
    '/user-support/conversations',
    {
      params: status ? { status } : {},
    }
  );
  return res.data.data;
}

export async function getMessages(
  conversationId: string
): Promise<PaginatedResponse<UserSupportMessageDTO>> {
  const res = await api.get<PaginatedResponse<UserSupportMessageDTO>>(
    `/user-support/conversations/${conversationId}/messages`,
    { params: { limit: 100 } }
  );
  return res.data;
}

export async function sendMessage(
  conversationId: string,
  content: string,
  files: File[] = []
): Promise<UserSupportMessageDTO> {
  const form = new FormData();
  form.append('conversationId', conversationId);
  form.append('content', content);
  files.forEach((f) => form.append('files', f));
  const res = await api.post<ApiResponse<UserSupportMessageDTO>>('/user-support/messages', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data.data;
}

/** Staff opens (or reuses) the support thread of a client. Idempotent server-side. */
export async function openThread(userId: string): Promise<UserSupportConversationDTO> {
  const res = await api.post<ApiResponse<UserSupportConversationDTO>>(
    `/user-support/conversations/${userId}/open`
  );
  return res.data.data;
}

export async function markRead(conversationId: string): Promise<void> {
  await api.put(`/user-support/conversations/${conversationId}/read`);
}

export async function setStatus(
  conversationId: string,
  status: string,
  assignedAdminId?: string | null
): Promise<UserSupportConversationDTO> {
  const res = await api.put<ApiResponse<UserSupportConversationDTO>>(
    `/user-support/conversations/${conversationId}/status`,
    { status, assignedAdminId }
  );
  return res.data.data;
}

export async function assign(
  conversationId: string,
  assignedAdminId: string | null
): Promise<UserSupportConversationDTO> {
  const res = await api.put<ApiResponse<UserSupportConversationDTO>>(
    `/user-support/conversations/${conversationId}/assign`,
    { assignedAdminId }
  );
  return res.data.data;
}

export async function getUnreadCount(): Promise<number> {
  const res = await api.get<ApiResponse<{ count: number }>>('/user-support/unread-count');
  return res.data.data.count;
}
